import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {
  GridActionArray,
  GridActionNumeric,
  GridActionSearch,
  GridColumnState,
  GridState,
} from '@dmc/ui/tables';

const gridAdapter = createEntityAdapter<GridState>();

const gridSlice = createSlice({
  name: 'grid',
  initialState: gridAdapter.getInitialState(),
  reducers: {
    register: (state, action: PayloadAction<string>) => {
      gridAdapter.addOne(state, {
        id: action.payload,
        firstVisibleRow: 0,
        columnState: [],
        selectedRows: [],
      });
    },
    setSearch: (state, action: PayloadAction<GridActionSearch>) => {
      gridAdapter.updateOne(state, {
        id: action.payload.id,
        changes: {
          search: action.payload.search,
        },
      });
    },
    setFirstVisibleRow: (state, action: PayloadAction<GridActionNumeric>) => {
      gridAdapter.updateOne(state, {
        id: action.payload.id,
        changes: {
          firstVisibleRow: action.payload.value,
        },
      });
    },
    setColumnState: (state, action: PayloadAction<GridActionArray<GridColumnState>>) => {
      gridAdapter.updateOne(state, {
        id: action.payload.id,
        changes: {
          columnState: action.payload.value,
        },
      });
    },
    setSelectedRows: (state, action: PayloadAction<GridActionArray<string>>) => {
      gridAdapter.updateOne(state, {
        id: action.payload.id,
        changes: {
          selectedRows: action.payload.value,
        },
      });
    },
    resetTable: (state, action: PayloadAction<string>) => {
      gridAdapter.updateOne(state, {
        id: action.payload,
        changes: {
          firstVisibleRow: 0,
          columnState: [],
          selectedRows: [],
          search: undefined,
        },
      });
    },
  },
});

export const { selectById: selectGridData } = gridAdapter.getSelectors<RootState>(
  state => state.grid,
);

export const {
  register,
  setSearch,
  setFirstVisibleRow,
  setColumnState,
  setSelectedRows,
  resetTable,
} = gridSlice.actions;

export default gridSlice.reducer;
